import { withRouter } from 'react-router-dom';
import Component from './component';

export default withRouter(Component);
